import Vue from 'vue'
import naver from 'vue-naver-maps'


Vue.use(naver, {
    clientID: process.env.VUE_APP_LEV ? 'ro4n0f6xs1' : 'f9ti1vn2qq',
    useGovAPI: false,
    subModules: '',
})
